import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  withStyles,
  withMobileDialog,
  Dialog,
  DialogActions,
  DialogContent,
  ListItem,
} from '@material-ui/core'
import Button from 'components/theme/Button'
import { list, create, read } from 'actions/data'
import { withRouter } from 'react-router-dom'
import { toggleDialog, toggleState } from 'actions/users'
import { selectUserAssignment } from 'actions/view'
import { Shopping } from 'mdi-material-ui'
import { openSnackbar } from 'actions/view'
// import { change } from 'actions/view'
import { getContactsWithEmails } from 'actions/contacts'

const styles = theme => ({
  notchedOutline: {
    borderRadius: 28,
    paddingLeft: '40px !important',
  },
  titleText: {
    marginBottom: 14,
    fontSize: 25,
    fontWeight: 'bold',
    color: '#014c94',
    [theme.breakpoints.down('sm')]: {
      fontSize: 19,
    },
  },
  paperFullWidth: {},
  paper: {
    border: '1px solid #adadad',
    borderRadius: 35,
  },
})

class UnassignedWarning extends Component {
  state = {
    open: false,
  }

  componentDidMount() {
    this.props.read(null, 'account/ap/status', null, 'none')
    if (this.props.enabled) {
      this.props.list('contact/a2', null, null, null, true, true)
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.enabled && this.props.enabled !== prevProps.enabled) {
      this.props.list('contact/a2', null, null, null, true, true)
    }
  }

  render() {
    const {
      vr_role,
      list,
      anyUnassignedContacts,
      create,
      history,
      selectUserAssignment,
      toggleDialog,
      classes,
      fullScreen,
      enabled,
      userAssignment,
      usersDialogOpen,
      assignmentPools,
    } = this.props

    return vr_role === 'acctowner' && enabled && anyUnassignedContacts ? (
      <>
        <div
          style={{
            borderRadius: 25,
            border: '1px solid #000',
            padding: '13px 10px 13px 48px',
            position: 'relative',
            marginBottom: 10,
            backgroundColor: '#fff',
          }}
        >
          <div
            style={{
              position: 'absolute',
              left: 10,
              top: '50%',
              transform: 'translate(0, -50%)',
              borderRadius: '50%',
              height: 30,
              width: 30,
              backgroundColor: '#d5922c',
              color: '#fff',
              fontWeight: 'bold',
              fontSize: 27,
              textAlign: 'center',
            }}
          >
            !
          </div>
          You have unassigned contacts. Click{' '}
          <span
            onClick={() => this.setState({ open: true })}
            style={{
              color: '#008bd2',
              textDecoration: 'underline',
              cursor: 'pointer',
            }}
          >
            here
          </span>{' '}
          if you would like to add those contacts to an assignment pool
          {(userAssignment !== 'contact/a2' || usersDialogOpen) && (
            <>
              {' '}
              or click{' '}
              <span
                onClick={() => {
                  toggleDialog(false)
                  list('contact/a2', null, null, null, true, true).then(() => {
                    selectUserAssignment('contact/a2')
                    history.push('/contacts')
                  })
                }}
                style={{
                  color: '#008bd2',
                  textDecoration: 'underline',
                  cursor: 'pointer',
                }}
              >
                here
              </span>{' '}
              to manually add them below
            </>
          )}
          .
        </div>
        <Dialog
          fullScreen={fullScreen}
          open={this.state.open}
          onClose={() => this.setState({ open: false })}
          fullWidth
          maxWidth="sm"
          PaperProps={{
            style: {
              borderRadius: 22,
              textAlign: 'center',
              padding: 20,
            },
          }}
          classes={{ paperFullWidth: classes.paperFullWidth }}
        >
          <DialogContent>
            <div style={{ marginBottom: 10 }}>
              The system will automatically assign contacts to users based on
              the order defined in the assignment pool. Click an assignment pool
              below to continue.
            </div>
            <div style={{ maxHeight: 321, overflowY: 'auto' }}>
              {assignmentPools.map((pool, idx) => {
                const date = new Date(pool.when_created)

                return (
                  <ListItem
                    key={`assignmentPoolListItem${pool?.id}`}
                    button
                    onClick={() => {
                      this.setState({ open: false })
                      selectUserAssignment()
                      create({
                        entity: {
                          use_default_assignment_pool: pool?.name === 'default',
                          assignmentpool_id:
                            pool?.name === 'default' ? undefined : pool?.id,
                        },
                        noReturnValue: true,
                        path: `contact/assignall`,
                        hasSchema: false,
                        snackbarMessage: `Assigning contacts via ${
                          pool?.name || 'unknown'
                        }`,
                      }).then(payload => {
                        if (payload?.is_background_operation) {
                          this.props.openSnackbar({
                            type: 'success',
                            message: 'This may take a few minutes.',
                          })
                        } else {
                          this.props.getContactsWithEmails()
                          list('contact/a2', null, null, null, true, true)

                          this.props.openSnackbar({
                            type: 'success',
                            message: `Contacts successfully assigned via ${
                              pool?.name || 'unknown'
                            }`,
                          })
                        }
                      })
                    }}
                    classes={{ container: classes.listItemContainer }}
                    style={{
                      borderTop: idx === 0 ? '1px solid gray' : null,
                      borderLeft: '1px solid gray',
                      borderRight: '1px solid gray',
                      borderBottom: '1px solid gray',
                      borderTopLeftRadius: idx === 0 ? 17 : null,
                      borderTopRightRadius: idx === 0 ? 17 : null,
                      borderBottomLeftRadius:
                        idx === assignmentPools?.length - 1 ? 17 : null,
                      borderBottomRightRadius:
                        idx === assignmentPools?.length - 1 ? 17 : null,
                      padding: 10,
                    }}
                    className={
                      idx % 2 === 0 ? classes.listItem : classes.listItemOdd
                    }
                  >
                    <Shopping
                      style={{
                        color: '#014c94',
                        marginRight: 5,
                        fontSize: 36,
                      }}
                    />
                    <div style={{ display: 'inline-block' }}>
                      <div
                        style={{
                          fontWeight: 'bold',
                          color: '#014c94',
                          fontSize: 20,
                        }}
                      >
                        {pool.name}
                      </div>
                      <div>
                        <span style={{ fontWeight: 'bold' }}>Created: </span>
                        <span style={{ color: '#014c94', fontWeight: 'bold' }}>
                          {date.toLocaleDateString()}
                        </span>
                      </div>
                    </div>
                    {/* <ListItemSecondaryAction>
                    <IconButton>
                      <MoreVert />
                    </IconButton>
                  </ListItemSecondaryAction> */}
                  </ListItem>
                )
              })}
            </div>
          </DialogContent>
          <DialogActions>
            {/* <Button
              onClick={() => {
                create({
                  entity: { use_default_assignment_pool: true },
                  entityType: 'contact/assignall',
                }).then(() => {
                  this.setState({ open: false })
                  list('contact/a2', null, null, null, true, true)
                })
              }}
            >
              Confirm
            </Button> */}
            <Button
              onClick={() => {
                this.setState({ open: false })
              }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </>
    ) : null
  }
}

export default withRouter(
  connect(
    state => ({
      vr_role: state.auth?.session?.idToken?.payload?.['custom:vr_role'],
      anyUnassignedContacts: Object.keys(state.data?.['contact/a2'] || {})
        .length,
      enabled: state.data?.['account/ap/status']?.enabled,
      userAssignment: state.sort?.userAssignment,
      usersDialogOpen: state.users?.dialogOpen,
      assignmentPools: Object.values(state.data?.['account/ap'] || {}),
    }),
    dispatch =>
      bindActionCreators(
        {
          list,
          create,
          selectUserAssignment,
          toggleDialog,
          toggleState,
          read,
          // change,
          openSnackbar,
          getContactsWithEmails,
        },
        dispatch,
      ),
  )(withStyles(styles)(withMobileDialog()(UnassignedWarning))),
)
